export const TaskList = {
  "request_id": "RT1611906846070437",
  "error_code": 0,
  "error_msg": "",
  "data": {
      "list": [
          {
              "id": 100012,
              "type": 0,
              "expected": "2021-02-01 13:03:59",
              "expected_date": "2021-02-01",
              "expected_time": "13:03:59",
              "start_time": null,
              "end_time": null,
              "level": 1,
              "currency_type": "CNY",
              "fee": 0,
              "note": "123456",
              "feedback": "不好打扫的。。。。",
              "photos": [
                  {
                      "filename": "GBF1611631824222.jpg",
                      "original_url": "https://oss.image.xiaogetech.com/GBF1611631824222.jpg",
                      "small_url": "https://oss.image.xiaogetech.com/GBF1611631824222.jpg/small",
                      "medium_url": "https://oss.image.xiaogetech.com/GBF1611631824222.jpg/medium",
                      "large_url": "https://oss.image.xiaogetech.com/GBF1611631824222.jpg/large",
                      "extra_large_url": "https://oss.image.xiaogetech.com/GBF1611631824222.jpg/xlarge",
                      "extra_extra_large_url": "https://oss.image.xiaogetech.com/GBF1611631824222.jpg/xxlarge"
                  }
              ],
              "status": 1,
              "house_id": 3117,
              "house": {
                  "id": 3117,
                  "title_alias": "百居易门锁测试房间B"
              }
          },
          {
              "id": 100012,
              "type": 1,
              "expected": "2021-01-29 13:03:59",
              "expected_date": "2021-02-01",
              "expected_time": "16:03:59",
              "start_time": null,
              "end_time": null,
              "level": 1,
              "currency_type": "CNY",
              "fee": 0,
              "note": "123456",
              "feedback": "不好打扫的。。。。",
              "photos": [
                  {
                      "filename": "GBF1611631824222.jpg",
                      "original_url": "https://oss.image.xiaogetech.com/GBF1611631824222.jpg",
                      "small_url": "https://oss.image.xiaogetech.com/GBF1611631824222.jpg/small",
                      "medium_url": "https://oss.image.xiaogetech.com/GBF1611631824222.jpg/medium",
                      "large_url": "https://oss.image.xiaogetech.com/GBF1611631824222.jpg/large",
                      "extra_large_url": "https://oss.image.xiaogetech.com/GBF1611631824222.jpg/xlarge",
                      "extra_extra_large_url": "https://oss.image.xiaogetech.com/GBF1611631824222.jpg/xxlarge"
                  }
              ],
              "status": 0,
              "house_id": 3117,
              "house": {
                  "id": 3117,
                  "title_alias": "百居易门锁测试房间B"
              }
          },
          {
              "id": 100012,
              "type": 2,
              "expected": "2021-01-29 13:03:59",
              "expected_date": "2021-02-02",
              "expected_time": "13:03:59",
              "start_time": null,
              "end_time": null,
              "level": 1,
              "currency_type": "CNY",
              "fee": 0,
              "note": "123456",
              "feedback": "不好打扫的。。。。",
              "photos": [
                  {
                      "filename": "GBF1611631824222.jpg",
                      "original_url": "https://oss.image.xiaogetech.com/GBF1611631824222.jpg",
                      "small_url": "https://oss.image.xiaogetech.com/GBF1611631824222.jpg/small",
                      "medium_url": "https://oss.image.xiaogetech.com/GBF1611631824222.jpg/medium",
                      "large_url": "https://oss.image.xiaogetech.com/GBF1611631824222.jpg/large",
                      "extra_large_url": "https://oss.image.xiaogetech.com/GBF1611631824222.jpg/xlarge",
                      "extra_extra_large_url": "https://oss.image.xiaogetech.com/GBF1611631824222.jpg/xxlarge"
                  }
              ],
              "status": 2,
              "house_id": 3117,
              "house": {
                  "id": 3117,
                  "title_alias": "百居易门锁测试房间B"
              }
          },
          {
              "id": 100012,
              "type": 3,
              "expected": "2021-01-29 13:03:59",
              "expected_date": "2021-02-04",
              "expected_time": "13:03:59",
              "start_time": null,
              "end_time": null,
              "level": 1,
              "currency_type": "CNY",
              "fee": 0,
              "note": "123456",
              "feedback": "不好打扫的。。。。",
              "photos": null,
              "status": 1,
              "house_id": 3117,
              "house": {
                  "id": 3117,
                  "title_alias": "百居易门锁测试房间B"
              }
          },
          {
              "id": 100012,
              "type": 4,
              "expected": "2021-01-29 13:03:59",
              "expected_date": "2021-02-05",
              "expected_time": "13:03:59",
              "start_time": null,
              "end_time": null,
              "level": 1,
              "currency_type": "CNY",
              "fee": 0,
              "note": "123456",
              "feedback": "不好打扫的。。。。",
              "photos": null,
              "status": 0,
              "house_id": 3117,
              "house": {
                  "id": 3117,
                  "title_alias": "百居易门锁测试房间B"
              }
          },
      ],
      "count": 1
  }
};